// extracted by mini-css-extract-plugin
module.exports = {"service-box":"Service_service-box__2-3uh","active":"Service_active__PESP4","service-title":"Service_service-title__1vFAP"};